import { render, staticRenderFns } from "./DepositSummaryCard.vue?vue&type=template&id=15169504&"
import script from "./DepositSummaryCard.vue?vue&type=script&lang=js&"
export * from "./DepositSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./DepositSummaryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports